import * as yup from 'yup';

export const AmputationSchema = yup.object({
  description: yup.string().required(),
  date: yup.string().required(),
});

export interface IAmputation {
  description: string;
  date: string;
}
